// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_bootstrap_tsx":"95781b9c","vendors-node_modules_presta-prenda-front-ds-revamped_dist_index_js":"682fd739"}[chunkId] + ".css";
};